import React, { Component } from 'react'
import axios from 'axios'
import ScoringNavbar from './components/ScoringNavbar'
import Hypnogram from './components/Hypnogram'
//import MultichannelChart from './components/MultichannelChart'
import SignalPanel from './components/SignalPanel'
//import SplitPane from 'react-split-pane'
import './edit.css'
//import EventInfoWindow from './components/EventInfoWindow'
import EventsDataStructure from './EventsDataStructure'
import TimeController from './TimeController'
import DataManager from './DataManager'
import DataRequestManager from './DataRequestManager'
import PauseRequestManager from './PauseRequestManager'
import getChannelEvents from './config/getChannelEvents'
import dataDisplay from './config/dataDisplay'
import channelNameToChannelId from './config/channelNameToChannelId'
import units from './config/units'
import channelColors from './config/channelColors'
import constants from './const'
import formatSecond from './components/functions/formatSecond'
import formatClockTime from './components/functions/formatClockTime'

import {
	upperLabelsForScale,
	lowerLabelsForScale
} from './config/labelsForScale'
import {
	jump
} from './config/FakeData'
import {
	upperConstLabels,
	lowerConstLabels
} from './config/constLabels'
import {
	getVerticalLines,
	getUpperHorizontalLines,
	getLowerHorizontalLines
} from './config/lines'
import { totalSWTime } from './components/functions/TotalSWTime'
import { computeAmplitude } from './components/functions/computeAmplitude'
import {
	calculateEpochEventAgreement,
	calculateEventAgreement,
	hasAgreementChanged,
	isSecondLevelEventAgreementEnabled
} from './components/functions/calculateEventAgreement'
import {
	ADMIN_ACCOUNT,
	isBatchDownloadRouteMissing,
	readAdminActionError,
	requestAgreementRecalculation,
	saveBatchWorkshopReports
} from '../commonComponents/adminActions'
//import { HashRouter } from 'react-router-dom'
const stageIntToString = Object.freeze({
	0: 'W',
	1: '1',
	2: '2',
	3: '3',
	'-1': 'R',
	'-2': 'RWA',
	10: ''
})
function getMasterEventAgreementSource(mseventResponse) {
	return {
		// Exact expert intervals are required for second-level agreement.
		events: Array.isArray(mseventResponse.events) ? mseventResponse.events : undefined,
		rows: mseventResponse.data
	}
}

function shouldRecalculateAgreement(psgFileId, mseventResponse, savedAgreement) {
	if (isSecondLevelEventAgreementEnabled(psgFileId)) {
		// Without exact expert intervals, a true second-level agreement cannot be calculated.
		return Array.isArray(mseventResponse.events)
	}
	// Preserve historical behavior for older PSG files.
	return !Array.isArray(savedAgreement) || savedAgreement.length === 0
}

function calculateConfiguredEventAgreement(psgFileId, events, mseventResponse, totalEpoch, userEpochs, legacyEpochCount) {
	if (isSecondLevelEventAgreementEnabled(psgFileId)) {
		return calculateEventAgreement(events, getMasterEventAgreementSource(mseventResponse), totalEpoch)
	}
	return calculateEpochEventAgreement(userEpochs, mseventResponse.data, legacyEpochCount)
}

class Scoring extends Component {
	constructor(props) {
		super(props)
		this.state = {
			display: false,
			cursorSecond: 0,
			upperSecondFrom: 0,
			upperSecondTo: 30,
			lowerSecondFrom: 0,
			lowerSecondTo: 30,
			upperData: [],
			lowerData: [],
			preUpperData: [],
			preLowerData: [],
			nextUpperData: [],
			nextLowerData: [],
			upperLabels: [],
			lowerLabels: [],
			upperEvents: [],
			lowerEvents: [],
			swEvents: [],
			snoreEvents: [],
			upperSelectedItem: '30 sec',
			lowerSelectedItem: '30 sec',
			stages: [],
			upperStages: [],
			lowerStages: [],
			answer: null, // 機器判讀結果
			hasAnswer: false,
			enableShowAnswerCheckbox: true,
			currentEpoch: 0,
			totalSWTimeEpoch: 0,

			psgFileId: parseInt(props.match.params.id),
			which: parseInt(props.match.params.which), // 0 -> 編輯中
			editable: parseInt(props.match.params.which) === 0,

			stateToShow: '',

			hasStagesBeenLoaded: false,
			hasNotCompleted: true,
			hasSubmitted: false,

			modeArr: null,

			all_event: [],
			arousal_s: [],
			spo2_s: [],
			msevent: [],
			masterEvents: null,
			spo2_deast: [],
			spo2_respiratory: [],
			Mixed_Apnea_s: [],
			Obstructive_Apnea_s: [],
			Central_Apnea_s: [],
			Hypopnea_s: [],
			limb_r_s: [],
			totalEpoch: 0,
			startTime: '2000-01-01 00:00:00',
			memos: [],
			recalculatingAgreements: false,
			downloadingBatchReports: false,
		}

		this.jumpTo = this.jumpTo.bind(this)
		this.addEvent = this.addEvent.bind(this)
		this.deleteEvent = this.deleteEvent.bind(this)
		this.moveCursor = this.moveCursor.bind(this)
		this.zoomChannel = this.zoomChannel.bind(this)
		this.setEventType = this.setEventType.bind(this)
		this.getEventInfo = this.getEventInfo.bind(this)
		this.addMemo = this.addMemo.bind(this)
		this.editMemo = this.editMemo.bind(this)
		this.deleteMemo = this.deleteMemo.bind(this)
		this.recalculateAllAgreements = this.recalculateAllAgreements.bind(this)
		this.downloadBatchWorkshopReports = this.downloadBatchWorkshopReports.bind(this)

		this.upperSelectItem = this.upperSelectItem.bind(this)
		this.lowerSelectItem = this.lowerSelectItem.bind(this)

		this.setStateFromDataStructure = this.setStateFromDataStructure.bind(this)

		// some data struct
		this.eventDataStructure = null // new EventsDataStructure([])
		this.swDataStructure = null
		this.snoreDataStructore = null
		this.timeController = null // new TimeController(jump, totalEpoch)
		this.stagesDataStructure = null // new Array(totalEpoch)
		this.answer = null // 機器判讀結果
		//this.stagesDataStructure.fill(0)
		this.dataManager = null
		this.dataRequestManager = null
		this.pauseRequestManager = null
		this.onKeyDown = this.onKeyDown.bind(this)
		this.onRequestComplete = this.onRequestComplete.bind(this)
		this.onStateChange = this.onStateChange.bind(this)
		this.pageDown = this.pageDown.bind(this)
		this.upperPageDown = this.upperPageDown.bind(this)
		this.lowerPageDown = this.lowerPageDown.bind(this)

		this.onShowAnswerChecked = this.onShowAnswerChecked.bind(this)

		this.bufferTimer = null
	}
	setStateFromDataStructure() {
		let cursorSecond = this.timeController.getCursorSecond()
		let upperSecondFrom = this.timeController.getUpperSecondFrom()
		let upperSecondTo = this.timeController.getUpperSecondTo()
		let lowerSecondFrom = this.timeController.getLowerSecondFrom()
		let lowerSecondTo = this.timeController.getLowerSecondTo()


		let upperData = this.dataManager.getData(upperSecondFrom, upperSecondTo, true)
		let lowerData = this.dataManager.getData(lowerSecondFrom, lowerSecondTo, false)

		// 看資料庫的 channel 資料是否有問題
		// console.log(`upperData: ${upperData}`)
		// console.log(`upperData[0]: ${JSON.stringify(upperData[0], null, 2)}`)
		// console.log(`upperData[0].data: ${upperData[0].data}`)
		// console.log("c3 data")
		// let map_func = upperData[0].data
		// for (let i = 1; i < upperData[0].dataLength; i++) {
		// 	console.log(`c3 x: ${i}, y: ${map_func(i)}`)
		// }

		// 上五頁資料
		let upperDataPeriod = upperSecondTo - upperSecondFrom;
		let preUpperData = [], preLowerData = [], nextUpperData = [], nextLowerData = [];
		for (let i = 0; i < 5; i++) {
			preUpperData[i] = this.dataManager.getData(upperSecondFrom - (i + 1) * upperDataPeriod, upperSecondTo - (i + 1) * upperDataPeriod, true);
		}
		let lowerDataPeriod = lowerSecondTo - lowerSecondFrom;
		for (let i = 0; i < 5; i++) {
			preLowerData[i] = this.dataManager.getData(lowerSecondFrom - (i + 1) * lowerDataPeriod, lowerSecondTo - (i + 1) * lowerDataPeriod, false);
		}
		// // 下五頁資料
		for (let i = 0; i < 5; i++) {
			nextUpperData[i] = this.dataManager.getData(upperSecondFrom + (i + 1) * upperDataPeriod, upperSecondTo + (i + 1) * upperDataPeriod, true);
		}
		for (let i = 0; i < 5; i++) {
			nextLowerData[i] = this.dataManager.getData(lowerSecondFrom + (i + 1) * lowerDataPeriod, lowerSecondTo + (i + 1) * lowerDataPeriod, false);
		}
		// console.log('upperData');
		//console.log(upperData);
		// console.log('preUpperData');
		// console.log(preUpperData);
		// console.log('nextUpperData');
		// console.log(nextUpperData);

		let upperLabels = []
		for (let i = 0; i < upperConstLabels.length; i++) {
			upperLabels.push(upperConstLabels[i])
		}
		// 2024 工作坊先拿掉左邊紅色字單位
		// let upperChannelKeys = Object.keys(upperLabelsForScale)
		// for (let i = 0; i < upperChannelKeys.length; i++) {
		// 	let channelId = upperChannelKeys[i]
		// 	let label = Object.assign({label: this.dataManager.getChannelRange(true, channelId) + ' ' + units[channelId]}, upperLabelsForScale[channelId])
		// 	upperLabels.push(label)
		// }

		const lowerChannelIdSet = new Set(this.dataManager.getLowerChannelIds())
		let lowerLabels = lowerConstLabels.filter(label => lowerChannelIdSet.has(label.channelId))
		if (this.state.psgFileId === 7 || this.state.psgFileId === 5) {
			lowerLabels = lowerLabels.map(label =>
				label.channelId === 11 ? Object.assign({}, label, { value: 65 }) : label
			)
		}
		// 2024 工作坊先拿掉左邊紅色字單位
		// let lowerChannelKeys = Object.keys(lowerLabelsForScale)
		// for (let i = 0; i < lowerChannelKeys.length; i++) {
		// 	let channelId = lowerChannelKeys[i]
		// 	let label = Object.assign({label: this.dataManager.getChannelRange(false, channelId) + ' ' + units[channelId]}, lowerLabelsForScale[channelId])
		// 	lowerLabels.push(label)
		// }

		let upperChannels = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
		let upperEventIds = this.eventDataStructure.getEventIdsByTimeRangeAndChannelIds(upperSecondFrom, upperSecondTo, upperChannels)
		let upperEvents = this.eventDataStructure.getEventObjectsByEventIds(upperEventIds)

		// 修改前（hardcode）
		// let lowerChannels = new Set([11, 12, 13, 14, 15, 16, 17, 18, 19, 20])

		// 修改後（因應2026題目，22channels，動態化）
		const lowerChannelIds = this.dataManager.getLowerChannelIds()
		let lowerChannels = new Set(lowerChannelIds)
		let lowerEventIds = this.eventDataStructure.getEventIdsByTimeRangeAndChannelIds(lowerSecondFrom, lowerSecondTo, lowerChannels)
		let lowerEvents = this.eventDataStructure.getEventObjectsByEventIds(lowerEventIds)
		//console.log('events', upperEvents, lowerEvents)
		let upperSelectedItem = this.timeController.getUpperTimeInterval()
		let lowerSelectedItem = this.timeController.getLowerTimeInterval()

		let swChannels = new Set([1, 2, 3, 4, 5, 6])
		let swEventIds = this.swDataStructure.getEventIdsByTimeRangeAndChannelIds(upperSecondFrom, upperSecondTo, swChannels)
		let swEvents = this.swDataStructure.getEventObjectsByEventIds(swEventIds)
		let swIntervals = []
		swEvents.forEach(swEvent => {
			if (swEvent.secondFrom >= upperSecondFrom && swEvent.secondTo <= upperSecondTo) {
				swIntervals.push([swEvent.secondFrom, swEvent.secondTo])
			}
		})
		let totalSWTimeEpoch = totalSWTime(swIntervals)

		let snoreChannels = new Set([11])
		let snoreEventIds = this.snoreDataStructure.getEventIdsByTimeRangeAndChannelIds(lowerSecondFrom, lowerSecondTo, snoreChannels)
		let snoreEvents = this.snoreDataStructure.getEventObjectsByEventIds(snoreEventIds)

		let stages = Array.from(this.stagesDataStructure)

		let upperEpochFrom = Math.floor(upperSecondFrom / 30)
		let upperEpochLength = Math.floor((upperSecondTo - upperSecondFrom) / 30)
		upperEpochLength = upperEpochLength === 0 ? 1 : upperEpochLength
		let upperStages = []
		for (let i = 0; i < upperEpochLength; i++) {
			let epoch = upperEpochFrom + i
			upperStages.push(stageIntToString[stages[epoch]])
		}
		let lowerEpochFrom = Math.floor(lowerSecondFrom / 30)
		let lowerEpochLength = Math.floor((lowerSecondTo - lowerSecondFrom) / 30)
		lowerEpochLength = lowerEpochLength === 0 ? 1 : lowerEpochLength
		let lowerStages = []
		for (let i = 0; i < lowerEpochLength; i++) {
			let epoch = lowerEpochFrom + i
			lowerStages.push(stageIntToString[stages[epoch]])
		}
		let currentEpoch = this.timeController.getCurrentEpoch()
		let buffered = this.dataManager.getBuffered()
		let hasNotCompleted = false
		for (let i = 0; i < stages.length; i++) {

			if (stages[i] === 10) {
				//console.log('stages[' + i + '] === 10')
				hasNotCompleted = true
				break
			}
		}
		//console.log('hasNotCompleted', hasNotCompleted)
		this.setState({
			display: true,
			upperLoading: !this.dataManager.hasData(upperSecondFrom, upperSecondTo, true),
			lowerLoading: !this.dataManager.hasData(lowerSecondFrom, lowerSecondTo, false),
			cursorSecond: cursorSecond,
			upperSecondFrom: upperSecondFrom,
			upperSecondTo: upperSecondTo,
			lowerSecondFrom: lowerSecondFrom,
			lowerSecondTo: lowerSecondTo,
			upperData: upperData,
			lowerData: lowerData,
			preUpperData: preUpperData,
			preLowerData: preLowerData,
			nextUpperData: nextUpperData,
			nextLowerData: nextLowerData,
			upperLabel: upperLabels,
			lowerLabel: lowerLabels,
			upperEvents: upperEvents,
			lowerEvents: lowerEvents,
			upperSelectedItem: upperSelectedItem,
			lowerSelectedItem: lowerSelectedItem,
			swEvents: swEvents,
			totalSWTimeEpoch: totalSWTimeEpoch,
			snoreEvents: snoreEvents,
			stages: stages,
			upperStages: upperStages,
			lowerStages: lowerStages,
			currentEpoch: currentEpoch,
			buffered: buffered,
			hasNotCompleted: hasNotCompleted,

		})
	}

	async _saveMemos(memos) {
		await axios.post('/ajax_save_memos', { psgFileId: this.state.psgFileId, memos })
	}
	addMemo(second, text) {
		const ids = this.state.memos.map(m => m.memoId)
		const nextId = ids.length > 0 ? Math.max(...ids) + 1 : 1
		const newMemos = [...this.state.memos, { memoId: nextId, second, text }]
		this.setState({ memos: newMemos })
		this._saveMemos(newMemos)
	}
	editMemo(memoId, text) {
		const newMemos = this.state.memos.map(m => m.memoId === memoId ? { ...m, text } : m)
		this.setState({ memos: newMemos })
		this._saveMemos(newMemos)
	}
	deleteMemo(memoId) {
		const newMemos = this.state.memos.filter(m => m.memoId !== memoId)
		this.setState({ memos: newMemos })
		this._saveMemos(newMemos)
	}
	async recalculateAllAgreements() {
		if (this.state.account !== ADMIN_ACCOUNT) return
		const confirmed = window.confirm(
			`確定要重新計算 PSG ${this.state.psgFileId} 所有已送出判讀的一致性嗎？\n此操作會更新 agreement_result。`
		)
		if (!confirmed) return

		this.setState({ recalculatingAgreements: true })
		try {
			const result = await requestAgreementRecalculation(this.state.psgFileId)
			if (!result.success) {
				alert(result.msg || '批次重算一致性失敗')
				return
			}

			console.log('[agreement recalculation result]', result)
			alert(
				`一致性重算完成\n` +
				`更新：${result.updated} 筆\n` +
				`警告：${(result.warnings || []).length} 筆\n` +
				`跳過：${result.skipped.length} 筆\n` +
				`失敗：${result.failed.length} 筆\n` +
				`算法：${result.algorithm}`
			)
		} catch (error) {
			if (error.response && error.response.status === 404) {
				alert(
					'批次重算 API 尚未部署到目前連線的後端。\n' +
					'請部署 backend_app.js、backend_agreement_calculator.js，' +
					'重新啟動後端服務，並確認 ' +
					'/recalculate_agreement 可被路由。'
				)
				return
			}
			const message = error.response && error.response.data && error.response.data.msg
				? error.response.data.msg
				: error.message
			alert('批次重算一致性失敗：' + message)
		} finally {
			this.setState({ recalculatingAgreements: false })
		}
	}

	async downloadBatchWorkshopReports() {
		if (this.state.account !== ADMIN_ACCOUNT) return
		const confirmed = window.confirm(
			`確定要從資料庫產生 PSG ${this.state.psgFileId} 第 ${this.state.which} 次所有已完成學員的工作坊報告嗎？\n` +
			'完成名單以 agreement_result 為準；失敗原因會記錄在 summary.csv。'
		)
		if (!confirmed) return

		this.setState({ downloadingBatchReports: true })
		try {
			await saveBatchWorkshopReports(this.state.psgFileId, this.state.which)
		} catch (error) {
			const message = await readAdminActionError(error)
			if (error.response && error.response.status === 404) {
				const routeMissing = isBatchDownloadRouteMissing(message)
				alert('批次下載工作坊報告失敗：' + message)
				return
			}
			alert('批次下載工作坊報告失敗：' + message)
		} finally {
			this.setState({ downloadingBatchReports: false })
		}
	}

	render() {
		//console.log('render')
		/*
		let upperStages = []
		let upperEpochNum = Math.floor((this.state.upperSecondTo - this.state.upperSecondFrom) / 30)
		upperEpochNum = upperEpochNum == 0 ? 1 : upperEpochNum // 如果不到一個epoch，就當作有一個epoch
		let upperEpochFrom = Math.floor(this.state.upperSecondFrom / 30)
		for (let i = 0; i < upperEpochNum; i++) {
			upperStages.push()
		}
		*/
		//console.log(this.timeController.getUpperTimeInterval())
		//console.log(this.state.upperEvents)
		//if (this.state.display === false) return <></>
		// if (!this.state.hasNetwork) {
		// 	alert('目前是斷線狀態\n資料將不會儲存\n請檢查網路連線');
		// 	window.location.reload();
		// 	return (
		// 		<div>
		// 			<h2>目前是斷線狀態</h2>
		// 			<h2>資料將不會儲存</h2>
		// 			<h2>請檢查網路連線</h2>
		// 		</div>
		// 	)
		// }
		// else {
		const reportStages = Array.isArray(this.stagesDataStructure)
			? this.stagesDataStructure.slice(0, this.state.totalEpoch)
			: this.state.stages
		return (
			<>
				<ScoringNavbar
					onComplete={async () => {
						var add_temp = 0
						for (let i in this.eventDataStructure.epochNumToEventId) {
							add_temp = add_temp + this.eventDataStructure.epochNumToEventId[i].size
						}
						if (add_temp > 0) {
							this.setState({
								hasSubmitted: true
							})
							this.pauseRequestManager.flush(async () => {
								let submitStageResult = await axios.post('/ajax_submit_stage', { psgFileId: this.state.psgFileId })
								if (!submitStageResult.data.success) {
									alert(submitStageResult.data.msg)
									window.history.go(0)
									return
								}
								window.location.href = "#"
							})
						} else {
							var answer = window.confirm("偵測到您尚未有arousal和呼吸事件，請問是否繳交?");
							if (answer) {
								this.setState({
									hasSubmitted: true
								})
								this.pauseRequestManager.flush(async () => {
									let submitStageResult = await axios.post('/ajax_submit_stage', { psgFileId: this.state.psgFileId })
									if (!submitStageResult.data.success) {
										alert(submitStageResult.data.msg)
										window.history.go(0)
										return
									}
									window.location.href = "#"
								})
							} else {
								//未繳交
							}
						}
						let scoring_times = (await axios.post('/get_scoring_times', { psgFileId: this.state.psgFileId })).data.scoringTimes + 1
						let chSegRes = (await axios.post('/ajax_ch_seg', { psgFileId: this.state.psgFileId })).data
						let totalEpoch = chSegRes.totalEpochNumber
						let msevent_read = await axios.post('/msevent', { psgFileId: this.state.psgFileId })
						this.setState({
							msevent: msevent_read.data.data,
							masterEvents: Array.isArray(msevent_read.data.events) ? msevent_read.data.events : null,
						})
						let loadResultResult = await axios.post('/ajax_load_result', { psgFileId: this.state.psgFileId, scoringTimes: scoring_times })
						console.log(loadResultResult)
						if (!loadResultResult.data.success) {
							alert(loadResultResult.data.msg)
							window.history.go(0)
							return
						}
						let events = loadResultResult.data.events
						for (let i = 1; i <= events.length; i++) {
							events[i - 1].eventId = i
						}
						this.eventDataStructure = new EventsDataStructure(events, channelColors, {}, {})
						let Mixed_Apnea_s = Array(totalEpoch).fill(0), Obstructive_Apnea_s = Array(totalEpoch).fill(0), Central_Apnea_s = Array(totalEpoch).fill(0), Hypopnea_s = Array(totalEpoch).fill(0), arousal_s = Array(totalEpoch).fill(0), spo2_s = Array(totalEpoch).fill(0), limb_r_s = Array(totalEpoch).fill(0), spo2_fl = new Array(), spo2_tl = new Array()
						let tcco2_s = Array(totalEpoch).fill(0)
						let tco2_s = Array(totalEpoch).fill(0)

						let duration_start = new Array(), duration_end = new Array()
						for (const [_, value] of Object.entries(this.eventDataStructure.eventIdToEventObject)) {
							const epochSecondTo = value.secondTo === Mixed_Apnea_s.length * 30 ? value.secondTo - 1 : value.secondTo
							if (value.type === "Mixed Apnea") {
								Mixed_Apnea_s[Math.floor(value.secondFrom / 30)] = 1
								Mixed_Apnea_s[Math.floor(epochSecondTo / 30)] = 1
								duration_start.push(value.secondFrom)
								duration_end.push(value.secondTo)
							}
							else if (value.type === "Obstructive Apnea") {
								Obstructive_Apnea_s[Math.floor(value.secondFrom / 30)] = 1
								Obstructive_Apnea_s[Math.floor(epochSecondTo / 30)] = 1
								duration_start.push(value.secondFrom)
								duration_end.push(value.secondTo)
							}
							else if (value.type === "Central Apnea") {
								Central_Apnea_s[Math.floor(value.secondFrom / 30)] = 1
								Central_Apnea_s[Math.floor(epochSecondTo / 30)] = 1
								duration_start.push(value.secondFrom)
								duration_end.push(value.secondTo)
							}
							else if (value.type === "Obstructive Hypopnea" || value.type === "Central Hypopnea" || value.type === "Mixed Hypopnea") {
								Hypopnea_s[Math.floor(value.secondFrom / 30)] = 1
								Hypopnea_s[Math.floor(epochSecondTo / 30)] = 1
								duration_start.push(value.secondFrom)
								duration_end.push(value.secondTo)
							}
							else if (value.type === "ARO SPONT") {
								arousal_s[Math.floor(value.secondFrom / 30)] = 1
								arousal_s[Math.floor(epochSecondTo / 30)] = 1
							}
							else if (value.type === "SpO2 Desat") {
								spo2_s[Math.floor(value.secondFrom / 30)] = 1
								spo2_s[Math.floor(epochSecondTo / 30)] = 1
								spo2_fl.push(value.secondFrom)
								spo2_tl.push(value.secondTo)
							}
							else if (value.type === "Limb movement (Right)" || value.type === "Limb movement (Left)") {
								limb_r_s[Math.floor(value.secondFrom / 30)] = 1
								limb_r_s[Math.floor(epochSecondTo / 30)] = 1
							}
							else if (value.type === "TcCO2 Event") {
								tcco2_s[Math.floor(value.secondFrom / 30)] = 1
								tcco2_s[Math.floor(epochSecondTo / 30)] = 1
							}
							else if (value.type === "TcO2 Desat") {
								tco2_s[Math.floor(value.secondFrom / 30)] = 1
								tco2_s[Math.floor(epochSecondTo / 30)] = 1
							}
						}
						let spo2_count = await axios.post('/calculate_spo2', { psgFileId: this.state.psgFileId, timeA: spo2_fl, timeB: spo2_tl })
						let mean_spo2_with_respiratory_events = await axios.post('/calculate_spo2_respiratory', { psgFileId: this.state.psgFileId, duration_start: duration_start, duration_end: duration_end })
						this.setState({
							all_event: this.eventDataStructure.eventIdToEventObject,
							Mixed_Apnea_s: Mixed_Apnea_s,
							Obstructive_Apnea_s: Obstructive_Apnea_s,
							Central_Apnea_s: Central_Apnea_s,
							Hypopnea_s: Hypopnea_s,
							arousal_s: arousal_s,
							spo2_s: spo2_s,
							limb_r_s: limb_r_s,
							spo2_deast: spo2_count.data.spo2,
							spo2_respiratory: mean_spo2_with_respiratory_events.data.spo2_respiratory
						})
						this.timeController = new TimeController(jump, totalEpoch)
						this.stagesDataStructure = loadResultResult.data.stages
						this.pauseRequestManager = null
						let statResult = await axios.post('/ajax_load_stat', { psgFileId: this.state.psgFileId })
						if (!statResult.data.success) {
							alert(statResult.data.msg)
							window.history.go(0)
							return
						} else {
							let stat = statResult.data.stat
							let epochAndStageToCount = new Array(totalEpoch)
							for (let i = 0; i < epochAndStageToCount.length; i++) {
								epochAndStageToCount[i] = {
									'-1': 0,
									'3': 0,
									'2': 0,
									'1': 0,
									'0': 0,
									'-2': 0
								}
							}
							for (let i = 0; i < stat.length; i++) {
								let epoch = stat[i].epoch
								let stage = stat[i].stage
								let count = stat[i].count
								epochAndStageToCount[epoch][stage] = count
							}
							var modeArr = new Array(totalEpoch)
							for (let i = 0; i < epochAndStageToCount.length; i++) {
								let max = 0
								let maxKey = null
								let keys = Object.keys(epochAndStageToCount[i])
								for (let j = keys.length - 1; j >= 0; j--) {
									if (epochAndStageToCount[i][keys[j]] > max) {
										max = epochAndStageToCount[i][keys[j]]
										maxKey = keys[j]
									}
								}
								modeArr[i] = parseInt(maxKey)
							}
							this.setState({
								modeArr: modeArr
							})
						}
						let get_agreement = await axios.post('/get_agreement', { psgFileId: this.state.psgFileId, scoringTimes: scoring_times })
						if (shouldRecalculateAgreement(this.state.psgFileId, msevent_read.data, get_agreement.data.agreement)) {
							let agreement = []
							let same_stage = 0, same_limb = 0;
							let agreement_stage = null, agreement_respiratory = null, agreement_arousal = null, agreement_spo2 = null, agreement_limb = null, agreement_rwa = null
							let rwa_agreement_numerator = 0;
							let rwa_agreement_denominator = 0;
							let same_tcco2 = 0, same_tco2 = 0;
							const eventAgreement = calculateConfiguredEventAgreement(
								this.state.psgFileId,
								events,
								msevent_read.data,
								totalEpoch,
								{
									hypopnea: Hypopnea_s,
									obstructiveApnea: Obstructive_Apnea_s,
									centralApnea: Central_Apnea_s,
									mixedApnea: Mixed_Apnea_s,
									arousal: arousal_s,
									spo2: spo2_s
								},
								this.stagesDataStructure.length
							)

							for (let i = 0; i < this.stagesDataStructure.length; i++) {
								if (modeArr[i] === this.stagesDataStructure[i] ||
									(modeArr[i] === -2 && this.stagesDataStructure[i] === -1 ||
										modeArr[i] === -1 && this.stagesDataStructure[i] === -2)) { // 2025 工作坊新增 RWA
									same_stage++
								}

								if (modeArr[i] === -1 || modeArr[i] === -2) {
									rwa_agreement_denominator++;

									if ((this.stagesDataStructure[i] === -2 && modeArr[i] === -2) ||  // 雙方都是 RWA
										(this.stagesDataStructure[i] === -1 && modeArr[i] === -1)) {  // 雙方都不是 RWA（都是 REM）
										rwa_agreement_numerator++;
									}
								}
								if (msevent_read.data.data[6][i] === limb_r_s[i]) {
									same_limb++;
								}
								// if (msevent_read.data.data[7][i] === tcco2_s[i]) {
								// 	same_tcco2++
								// }
								// if (msevent_read.data.data[8][i] === tco2_s[i]) {
								// 	same_tco2++
								// }
							}
							agreement_stage = ((same_stage / this.stagesDataStructure.length) * 100).toFixed(1)
							// 2025 工作坊新增 RWA
							agreement_rwa = rwa_agreement_denominator === 0 ? null : ((rwa_agreement_numerator / rwa_agreement_denominator) * 100).toFixed(1)
							agreement_respiratory = eventAgreement.respiratory
							agreement_arousal = eventAgreement.arousal
							agreement_spo2 = eventAgreement.spo2
							agreement_limb = ((same_limb / this.stagesDataStructure.length) * 100).toFixed(1);

							const toAgreementVal = (v) => (v === null || isNaN(parseFloat(v))) ? null : v
							agreement.push(toAgreementVal(agreement_stage))
							agreement.push(toAgreementVal(agreement_respiratory))
							agreement.push(toAgreementVal(agreement_arousal))
							agreement.push(toAgreementVal(agreement_spo2))
							agreement.push(toAgreementVal(agreement_limb))
							agreement.push(toAgreementVal(agreement_rwa))

							if (hasAgreementChanged(get_agreement.data.agreement, agreement)) {
								let set_agreement = await axios.post('/set_agreement', { agreement: agreement, psgFileId: this.state.psgFileId, scoringTimes: scoring_times })
								if (!set_agreement.data.success) {
									alert(set_agreement.data.msg)
									window.history.go(0)
									return
								}
							}
						}
					}}
					logout={() => {
						console.log('logout')
					}}
					stateToShow={this.state.stateToShow}
					editable={this.state.editable}
					account={this.state.account}
					onRecalculateAllAgreements={this.recalculateAllAgreements}
					recalculatingAgreements={this.state.recalculatingAgreements}
					onDownloadBatchWorkshopReports={this.downloadBatchWorkshopReports}
					downloadingBatchReports={this.state.downloadingBatchReports}
					onLogout={() => {
						window.location.href = "#"
					}}
					onShowAnswerChecked={this.onShowAnswerChecked}
					stage={reportStages}
					all_event={this.state.all_event}
					Mixed_Apnea_s={this.state.Mixed_Apnea_s}
					Obstructive_Apnea_s={this.state.Obstructive_Apnea_s}
					Central_Apnea_s={this.state.Central_Apnea_s}
					Hypopnea_s={this.state.Hypopnea_s}
					limb_r_s={this.state.limb_r_s}
					arousal_s={this.state.arousal_s}
					spo2_s={this.state.spo2_s}
					enableShowAnswerCheckbox={this.state.enableShowAnswerCheckbox}
					spo2_deast={this.state.spo2_deast}
					spo2_respiratory={this.state.spo2_respiratory}
					hasAnswer={this.state.hasAnswer}
					modeArr={this.state.modeArr}
					msevent={this.state.msevent}
					masterEvents={this.state.masterEvents}
					// ********* ****** ScoringNavBar接了psgFileId但這邊原本不給
					psgFileId={this.state.psgFileId}
					buttonDisabled={(this.state.hasNotCompleted) || (this.state.hasSubmitted)}
					hasStagesBeenLoaded={this.state.hasStagesBeenLoaded}
					totalEpoch={this.state.totalEpoch}
					totalSWTimeEpoch={this.state.totalSWTimeEpoch} />
				{this.state.display && (!this.state.hasSubmitted) ?
					<>
						<Hypnogram
							leftSpace={20}
							rightSpace={10}
							topSpace={5}
							bottomSpace={5}
							stages={this.state.stages}
							modeArr={this.state.modeArr}
							answer={this.state.answer}
							currentEpoch={this.state.currentEpoch}
							jumpTo={this.jumpTo}
							buffered={this.state.buffered} />
						{<div style={{
							position: 'absolute',
							textAlign: 'center',
							fontWeight: 'bold',
							left: '0px',
							right: '0px',
							height: '0px',
							top: '52px',
							color: 'red',
							fontSize: '24px',
							opacity: '40%'
						}}>
							{
								// 'Cursor: ' + formatSecond(this.state.cursorSecond) +
								'Cursor: ' + formatClockTime(this.state.cursorSecond, this.state.startTime) +
								', Epoch: ' + (((parseInt(this.state.currentEpoch) + 1) !== 1) ? (parseInt(this.state.currentEpoch) + 1) : (parseInt(this.state.currentEpoch) + 1)) +
								' - ' + stageIntToString[this.state.stages[this.state.currentEpoch]]
							}
						</div>}
						<SignalPanel
							currentEpoch={this.state.currentEpoch}
							upperLoading={this.state.upperLoading}
							lowerLoading={this.state.lowerLoading}
							editable={this.state.editable}
							upperPageDown={this.upperPageDown}
							lowerPageDown={this.lowerPageDown}
							addEvent={this.addEvent}
							deleteEvent={this.deleteEvent}
							setEventType={this.setEventType}
							moveCursor={this.moveCursor}
							zoomChannel={this.zoomChannel}
							getEventInfo={this.getEventInfo}
							getChannelEvents={getChannelEvents}
							cursorSecond={this.state.cursorSecond}
							upperSecondFrom={this.state.upperSecondFrom}
							upperSecondTo={this.state.upperSecondTo}
							upperData={this.state.upperData}
							preUpperData={this.state.preUpperData}
							nextUpperData={this.state.nextUpperData}
							lowerSecondFrom={this.state.lowerSecondFrom}
							lowerSecondTo={this.state.lowerSecondTo}
							lowerData={this.state.lowerData}
							preLowerData={this.state.preLowerData}
							nextLowerData={this.state.nextLowerData}
							upperEvents={this.state.upperEvents}
							lowerEvents={this.state.lowerEvents}
							upperLabels={this.state.upperLabel}
							lowerLabels={this.state.lowerLabel}
							upperVerticalLines={getVerticalLines(this.timeController.getUpperTimeInterval())}
							upperHorizontalLines={getUpperHorizontalLines()}
							lowerVerticalLines={getVerticalLines(this.timeController.getLowerTimeInterval())}
							lowerHorizontalLines={getLowerHorizontalLines()}
							upperStages={this.state.upperStages}
							lowerStages={this.state.lowerStages}
							upperSelectItem={this.upperSelectItem}
							upperItems={['10 sec', '30 sec', '1 min', '2 min', '3 min', '5 min', '10 min']}
							upperSelectedItem={this.state.upperSelectedItem}
							lowerSelectItem={this.lowerSelectItem}
							lowerItems={['10 sec', '30 sec', '1 min', '2 min', '3 min', '5 min', '10 min']}
							lowerSelectedItem={this.state.lowerSelectedItem}
							swEvents={this.state.swEvents}
							snoreEvents={this.state.snoreEvents}
							psgFileId={this.state.psgFileId}
							memos={this.state.memos}
							addMemo={this.addMemo}
							editMemo={this.editMemo}
							deleteMemo={this.deleteMemo} />
					</> : null
				}
			</>
		)
		// }
	}
	SumDatareduce = (arr) => {
		return arr.reduce((a, b) => a + b);
	}
	async componentDidMount() {
		// this.interval = setInterval(() => this.networkDetect(), 3000)

		let account = (await axios.post('/ajax_who_am_i', {})).data.account
		if (account === undefined) {
			window.location.href = "#"
			return
		}
		this.setState({
			account: account
		})
		let chSegRes = (await axios.post('/ajax_ch_seg', { psgFileId: this.state.psgFileId })).data
		if (!chSegRes.success) {
			alert(chSegRes.msg)
			window.history.go(0)
			return
		}

		// if (this.state.psgFileId == 10) {
		// 	alert("第二次判讀已截止，正在計算一致性與整理名單資訊，\n請返回首頁")
		// 	return
		// }

		//console.log(chSegRes)
		let upperChannels = chSegRes.upperChannels
		let lowerChannels = chSegRes.lowerChannels
		let paramForDataManagerConstructor = []
		for (let i = 0; i < upperChannels.length; i++) {
			let channel = upperChannels[i]
			let channelId = channelNameToChannelId[channel.channelName]
			let element = {}
			element.offset = channel.offset
			element.dataLength = channel.length
			element.channelId = channelId
			element = Object.assign(element, dataDisplay[channelId])
			paramForDataManagerConstructor.push(element)
		}
		for (let i = 0; i < lowerChannels.length; i++) {
			let channel = lowerChannels[i]
			let channelId = channelNameToChannelId[channel.channelName]
			let element = {}
			element.offset = channel.offset
			element.dataLength = channel.length
			element.channelId = channelId
			element = Object.assign(element, dataDisplay[channelId])
			if ((this.state.psgFileId === 7 && channelId === 11) || (this.state.psgFileId === 5 && channelId === 11)) {
				element.originalMin = 55
				element.originalMax = 75
			}
			paramForDataManagerConstructor.push(element)
		}
		let totalEpoch = chSegRes.totalEpochNumber
		let startTime = chSegRes.startTime;
		this.setState({
			totalEpoch: totalEpoch,
			startTime: startTime ?? '2000-01-01 00:00:00'
		})
		// test
		//this.answer = new Array(totalEpoch)
		//this.answer.fill(0)

		this.dataManager = new DataManager(paramForDataManagerConstructor, totalEpoch)
		let psgFileId = parseInt(this.props.match.params.id)
		this.dataRequestManager = new DataRequestManager(psgFileId)
		const memoResult = await axios.post('/ajax_load_memos', { psgFileId })
		if (memoResult.data.success) {
			this.setState({ memos: memoResult.data.memos })
		}
		if (this.state.editable) {
			let loadPauseResult = await axios.post('/ajax_load_pause', { psgFileId: psgFileId })
			if (!loadPauseResult.data.success) {
				alert(loadPauseResult.data.msg)
				window.history.go(0)
				return
			}
			let swDetectResult = await axios.post('/get_sw_detect_result', { psgFileId: psgFileId })
			let snoreDetectResult = await axios.post('/get_snore_detect_result', { psgFileId: psgFileId })

			// this.eventDataStructure = new EventsDataStructure(loadPauseResult.data.events, channelColors, {1: 2, 13: 12, 14: 12, 15: 12}, {2: new Set([1]), 12: new Set([13, 14, 15])})
			this.eventDataStructure = new EventsDataStructure(loadPauseResult.data.events, channelColors, {}, {})
			this.swDataStructure = new EventsDataStructure(swDetectResult.data.sw_detect_result, channelColors, {}, {})
			this.snoreDataStructure = new EventsDataStructure(snoreDetectResult.data.snore_detect_result, channelColors, {}, {})
			this.timeController = new TimeController(loadPauseResult.data.jump, totalEpoch)

			this.stagesDataStructure = loadPauseResult.data.stages
			this.pauseRequestManager = new PauseRequestManager(psgFileId, this.onStateChange)
		} else {
			let msevent_read = await axios.post('/msevent', { psgFileId: psgFileId })
			this.setState({
				msevent: msevent_read.data.data,
				masterEvents: Array.isArray(msevent_read.data.events) ? msevent_read.data.events : null,
			})
			let loadResultResult = await axios.post('/ajax_load_result', { psgFileId: psgFileId, scoringTimes: this.state.which })
			if (!loadResultResult.data.success) {
				alert(loadResultResult.data.msg)
				window.history.go(0)
				return
			}
			let events = loadResultResult.data.events
			for (let i = 1; i <= events.length; i++) {
				events[i - 1].eventId = i
			}
			//console.log(events)

			let swDetectResult = await axios.post('/get_sw_detect_result', { psgFileId: psgFileId })
			let snoreDetectResult = await axios.post('/get_snore_detect_result', { psgFileId: psgFileId })

			// this.eventDataStructure = new EventsDataStructure(events, channelColors, {1: 2, 13: 12, 14: 12, 15: 12}, {2: new Set([1]), 12: new Set([13, 14, 15])})
			this.eventDataStructure = new EventsDataStructure(events, channelColors, {}, {})
			this.swDataStructure = new EventsDataStructure(swDetectResult.data.sw_detect_result, channelColors, {}, {})
			this.snoreDataStructure = new EventsDataStructure(snoreDetectResult.data.snore_detect_result, channelColors, {}, {})

			let Mixed_Apnea_s = Array(totalEpoch).fill(0), Obstructive_Apnea_s = Array(totalEpoch).fill(0), Central_Apnea_s = Array(totalEpoch).fill(0), Hypopnea_s = Array(totalEpoch).fill(0), arousal_s = Array(totalEpoch).fill(0), spo2_s = Array(totalEpoch).fill(0), limb_r_s = Array(totalEpoch).fill(0), spo2_fl = new Array(), spo2_tl = new Array()
			let tcco2_s = Array(totalEpoch).fill(0)
			let tco2_s = Array(totalEpoch).fill(0)

			let duration_start = new Array(), duration_end = new Array()
			for (const [_, value] of Object.entries(this.eventDataStructure.eventIdToEventObject)) {
				const epochSecondTo = value.secondTo === Mixed_Apnea_s.length * 30 ? value.secondTo - 1 : value.secondTo
				if (value.type === "Mixed Apnea") {
					Mixed_Apnea_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
					duration_start.push(value.secondFrom)
					duration_end.push(value.secondTo)
				}
				else if (value.type === "Obstructive Apnea") {
					Obstructive_Apnea_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
					duration_start.push(value.secondFrom)
					duration_end.push(value.secondTo)
				}
				else if (value.type === "Central Apnea") {
					Central_Apnea_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
					duration_start.push(value.secondFrom)
					duration_end.push(value.secondTo)
				}
				else if (value.type === "Obstructive Hypopnea" || value.type === "Central Hypopnea" || value.type === "Mixed Hypopnea") {
					Hypopnea_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
					duration_start.push(value.secondFrom)
					duration_end.push(value.secondTo)
				}
				else if (value.type === "ARO SPONT") {
					arousal_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
				}
				else if (value.type === "SpO2 Desat") {
					spo2_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
					spo2_fl.push(value.secondFrom)
					spo2_tl.push(value.secondTo)
				}
				else if (value.type === "Limb movement (Right)" || value.type === "Limb movement (Left)") {
					limb_r_s.fill(1, Math.floor(value.secondFrom / 30), Math.floor(epochSecondTo / 30) + 1)
				}
				else if (value.type === "TcCO2 Event") {
					tcco2_s[Math.floor(value.secondFrom / 30)] = 1
					tcco2_s[Math.floor(epochSecondTo / 30)] = 1
				}
				else if (value.type === "TcO2 Desat") {
					tco2_s[Math.floor(value.secondFrom / 30)] = 1
					tco2_s[Math.floor(epochSecondTo / 30)] = 1
				}
			}
			let spo2_count = await axios.post('/calculate_spo2', { psgFileId: psgFileId, timeA: spo2_fl, timeB: spo2_tl })
			let mean_spo2_with_respiratory_events = await axios.post('/calculate_spo2_respiratory', { psgFileId: psgFileId, duration_start: duration_start, duration_end: duration_end })
			this.setState({
				all_event: this.eventDataStructure.eventIdToEventObject,
				Mixed_Apnea_s: Mixed_Apnea_s,
				Obstructive_Apnea_s: Obstructive_Apnea_s,
				Central_Apnea_s: Central_Apnea_s,
				Hypopnea_s: Hypopnea_s,
				arousal_s: arousal_s,
				spo2_s: spo2_s,
				limb_r_s: limb_r_s,
				spo2_deast: spo2_count.data.spo2,
				spo2_respiratory: mean_spo2_with_respiratory_events.data.spo2_respiratory
			})
			this.timeController = new TimeController(jump, totalEpoch)
			this.stagesDataStructure = loadResultResult.data.stages
			this.pauseRequestManager = null

			let statResult = await axios.post('/ajax_load_stat', { psgFileId: psgFileId })
			if (!statResult.data.success) {
				alert(statResult.data.msg)
				window.history.go(0)
				return
			} else {
				let stat = statResult.data.stat
				let epochAndStageToCount = new Array(totalEpoch)
				for (let i = 0; i < epochAndStageToCount.length; i++) {
					epochAndStageToCount[i] = {
						'-1': 0,
						'3': 0,
						'2': 0,
						'1': 0,
						'0': 0,
						'-2': 0
					}
				}
				for (let i = 0; i < stat.length; i++) {
					let epoch = stat[i].epoch
					let stage = stat[i].stage
					let count = stat[i].count
					epochAndStageToCount[epoch][stage] = count
				}
				/* ********* ******
					2022以種子技師們"兩次"判讀的答案多數決產生golden standard
					平手狀況之處理方式劉老師表示未盡合理
					改為以第二次為基準，他投的最後一票再用setans帳號insert into資料庫
					btw JavaScript Object.keys()順序不可控
				********* ****** */
				var modeArr = new Array(totalEpoch)
				const keyOrder = ['-2', '3', '2', '-1', '1', '0']
				for (let i = 0; i < epochAndStageToCount.length; i++) {
					let max = 0
					let maxKey = null
					let keys = Object.keys(epochAndStageToCount[i])
					for (let j = keys.length - 1; j >= 0; j--) {
						// if (epochAndStageToCount[i][keys[j]] > max) {
						if ((epochAndStageToCount[i][keys[j]] > max) | (epochAndStageToCount[i][keys[j]] == max & keyOrder.indexOf(keys[j]) > keyOrder.indexOf(maxKey))) {
							max = epochAndStageToCount[i][keys[j]]
							maxKey = keys[j]
						}
					}
					modeArr[i] = parseInt(maxKey)
				}
				this.setState({
					modeArr: modeArr
				})
			}
			// /* ********* ******
			let get_agreement = await axios.post('/get_agreement', { psgFileId: psgFileId, scoringTimes: this.state.which })
			if (shouldRecalculateAgreement(psgFileId, msevent_read.data, get_agreement.data.agreement)) {
				let agreement = []
				let same_stage = 0, same_limb = 0;
				let agreement_stage = null, agreement_respiratory = null, agreement_arousal = null, agreement_spo2 = null, agreement_limb = null, agreement_rwa = null
				let rwa_agreement_numerator = 0;
				let rwa_agreement_denominator = 0;
				let same_tcco2 = 0, same_tco2 = 0;
				const eventAgreement = calculateConfiguredEventAgreement(
					psgFileId,
					events,
					msevent_read.data,
					totalEpoch,
					{
						hypopnea: Hypopnea_s,
						obstructiveApnea: Obstructive_Apnea_s,
						centralApnea: Central_Apnea_s,
						mixedApnea: Mixed_Apnea_s,
						arousal: arousal_s,
						spo2: spo2_s
					},
					this.stagesDataStructure.length
				)
				for (let i = 0; i < this.stagesDataStructure.length; i++) {
					if (modeArr[i] === this.stagesDataStructure[i] ||
						(modeArr[i] === -2 && this.stagesDataStructure[i] === -1 ||
							modeArr[i] === -1 && this.stagesDataStructure[i] === -2)) { // 2025 工作坊新增 RWA
						same_stage++
					}

					if (modeArr[i] === -1 || modeArr[i] === -2) {
						rwa_agreement_denominator++;

						if ((this.stagesDataStructure[i] === -2 && modeArr[i] === -2) ||  // 雙方都是 RWA
							(this.stagesDataStructure[i] === -1 && modeArr[i] === -1)) {  // 雙方都不是 RWA（都是 REM）


							rwa_agreement_numerator++;
						}
					}
					if (this.state.msevent[6][i] === limb_r_s[i]) {
						same_limb++;
					}
					// if (this.state.msevent[7][i] === tcco2_s[i]) {
					// 	same_tcco2++
					// }
					// if (this.state.msevent[8][i] === tco2_s[i]) {
					// 	same_tco2++
					// }
				}
				agreement_stage = ((same_stage / this.stagesDataStructure.length) * 100).toFixed(1)
				// 2025 工作坊新增 RWA
				agreement_rwa = rwa_agreement_denominator === 0 ? null : ((rwa_agreement_numerator / rwa_agreement_denominator) * 100).toFixed(1)
				agreement_respiratory = eventAgreement.respiratory
				agreement_arousal = eventAgreement.arousal
				agreement_spo2 = eventAgreement.spo2
				agreement_limb = ((same_limb / this.stagesDataStructure.length) * 100).toFixed(1)

				const toAgreementVal2 = (v) => (v === null || isNaN(parseFloat(v))) ? null : v
				agreement.push(toAgreementVal2(agreement_stage))
				agreement.push(toAgreementVal2(agreement_respiratory))
				agreement.push(toAgreementVal2(agreement_arousal))
				agreement.push(toAgreementVal2(agreement_spo2))
				agreement.push(toAgreementVal2(agreement_limb))
				agreement.push(toAgreementVal2(agreement_rwa))

				if (hasAgreementChanged(get_agreement.data.agreement, agreement)) {
					let set_agreement = await axios.post('/set_agreement', { agreement: agreement, psgFileId: psgFileId, scoringTimes: this.state.which })
					if (!set_agreement.data.success) {
						alert(set_agreement.data.msg)
						window.history.go(0)
						return
					}
				}
			}
			// ********* ****** */
		}
		let hasAnswerResult = await axios.post('/ajax_has_answer', { psgFileId: psgFileId })
		if (!hasAnswerResult.data.success) {
			alert(hasAnswerResult.data.msg)
			window.history.go(0)
			return
		}

		this.setState({
			hasStagesBeenLoaded: true,
			hasAnswer: hasAnswerResult.data.hasAnswer
			//hasNotCompleted: true
		})
		this.checkDataAndSendRequest()
		document.addEventListener('keydown', this.onKeyDown);
		//console.log(this)

		// test test
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
	}
	componentWillUnmount() {
		clearInterval(this.interval)
		//console.log('unmount')
		this.unmount = true
		document.removeEventListener('keydown', this.onKeyDown);
	}
	pageDown() {
		if (this.timeController === null) return
		this.timeController.pageDown()
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
	}
	upperPageDown() {
		if (this.timeController === null) return
		this.timeController.pageDownUpper()
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
	}
	lowerPageDown() {
		if (this.timeController === null) return
		this.timeController.pageDownLower()
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
	}
	onKeyDown(e) {
		//console.log('key down')
		//console.log(this)
		if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') return
		if (this.stagesDataStructure === null || this.timeController === null) return
		if (this.state.hasSubmitted) return
		let currentEpoch = this.timeController.getCurrentEpoch()
		let isValidCurrentEpoch = Number.isInteger(currentEpoch) &&
			currentEpoch >= 0 && currentEpoch < this.state.totalEpoch

		if (e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 34) { // right arrow
			this.pageDown()
		} else if (e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 33) { // left arrow
			this.timeController.pageUp()
			if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		}
		if (this.state.editable && isValidCurrentEpoch) if (e.keyCode === 192 || e.keyCode === 96 || e.keyCode === 48) { // wake
			this.stagesDataStructure[currentEpoch] = 0
			this.pauseRequestManager.editStage(currentEpoch, 0, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		} else if (e.keyCode === 49 || e.keyCode === 97) { // n1
			this.stagesDataStructure[currentEpoch] = 1
			this.pauseRequestManager.editStage(currentEpoch, 1, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		} else if (e.keyCode === 50 || e.keyCode === 98) { // n2
			this.stagesDataStructure[currentEpoch] = 2
			this.pauseRequestManager.editStage(currentEpoch, 2, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		} else if (e.keyCode === 51 || e.keyCode === 99) { // n3
			this.stagesDataStructure[currentEpoch] = 3
			this.pauseRequestManager.editStage(currentEpoch, 3, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		} else if (e.keyCode === 53 || e.keyCode === 101) { // rem
			this.stagesDataStructure[currentEpoch] = -1
			this.pauseRequestManager.editStage(currentEpoch, -1, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		}
		else if (e.keyCode === 54 || e.keyCode === 102) { // RWA (鍵盤6)
			this.stagesDataStructure[currentEpoch] = -2  // 然後在圖上是-2的位置(R的上面)
			this.pauseRequestManager.editStage(currentEpoch, -2, this.state.totalEpoch)
			this.timeController.nextEpoch()
			this.pauseRequestManager.editCurrentWindow(
				this.timeController.getUpperSecondFrom(),
				this.timeController.getLowerSecondFrom(),
				this.timeController.getUpperTimeInterval(),
				this.timeController.getLowerTimeInterval(),
				this.timeController.getCursorSecond(),
				this.state.totalEpoch
			)
			this.checkDataAndSendRequest()
			this.setStateFromDataStructure()
			//this.startBuffer()
		}

		// else if (window.event.shiftKey && e.keyCode === 191) { // ?
		// 	this.stagesDataStructure[currentEpoch] = -2
		// 	this.pauseRequestManager.editStage(currentEpoch, -2,this.state.totalEpoch)
		// 	this.timeController.nextEpoch()
		// 	this.pauseRequestManager.editCurrentWindow(
		// 		this.timeController.getUpperSecondFrom(),
		// 		this.timeController.getLowerSecondFrom(),
		// 		this.timeController.getUpperTimeInterval(),
		// 		this.timeController.getLowerTimeInterval(),
		// 		this.timeController.getCursorSecond(),
		// 		this.state.totalEpoch
		// 	)
		// 	this.checkDataAndSendRequest()
		// 	this.setStateFromDataStructure()
		// 	//this.startBuffer()
		// }
	}
	startBuffer() {
		let toBuffer = 0
		if (this.timeController.getCurrentEpoch() <= 5) {
			toBuffer = this.dataManager.getNextEpochToBuffer(-1)
		} else {
			toBuffer = this.dataManager.getNextEpochToBuffer(this.timeController.getCurrentEpoch() - 7)
		}
		if (toBuffer !== null) {
			//console.log(toBuffer.epoch)
			this.dataRequestManager.setRequest(toBuffer.upper ? [toBuffer.epoch] : [], toBuffer.lower ? [toBuffer.epoch] : [], this.onRequestComplete)
		}
	}
	onRequestComplete(data) {
		//console.log(data)
		//console.log('complete')
		if (this.unmount) return
		for (let i = 0; i < data.length; i++) {
			//console.log('set data', data[i].upper, data[i].epoch)
			this.dataManager.setData(data[i].data, data[i].epoch, data[i].upper)
		}
		this.setStateFromDataStructure()
		this.startBuffer()
	}
	checkDataAndSendRequest() {
		let upperSecondFrom = this.timeController.getUpperSecondFrom()
		let upperSecondTo = this.timeController.getUpperSecondTo()
		let upperNoEpochs = this.dataManager.checkData(upperSecondFrom, upperSecondTo, true)

		let lowerSecondFrom = this.timeController.getLowerSecondFrom()
		let lowerSecondTo = this.timeController.getLowerSecondTo()
		let lowerNoEpochs = this.dataManager.checkData(lowerSecondFrom, lowerSecondTo, false)
		//console.log('upper second', upperSecondFrom, upperSecondTo)
		//console.log('lower second', lowerSecondFrom, lowerSecondTo)
		//console.log('upper no data:', upperNoEpochs, 'lower no data:', lowerNoEpochs)
		//console.log('lower no data:', lowerNoEpochs)
		if (upperNoEpochs.length === 0 && lowerNoEpochs.length === 0) {
			//console.log('no request start buffer')
			this.startBuffer()
			return
		}
		this.dataRequestManager.setRequest(upperNoEpochs, lowerNoEpochs, (data) => { this.onRequestComplete(data) })
	}
	jumpTo(epoch) {
		//console.log('jump to', epoch)
		this.timeController.jumpToEpoch(epoch)
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
	}
	addEvent(channelId, secondFrom, secondTo, type, priority, amplitude = null) {
		//console.log('add event', channelId, secondFrom, secondTo, type, priority)
		secondFrom = parseFloat(secondFrom.toFixed(constants.floatToFixed))
		secondTo = parseFloat(secondTo.toFixed(constants.floatToFixed))
		let maxSec = this.stagesDataStructure.length * 30
		secondTo = secondTo > maxSec ? maxSec : secondTo
		if (amplitude === null && this.dataManager !== null) {
			const isUpper = [1, 2, 3, 4, 5, 6].includes(channelId)
			const isLower = channelId === 12 || channelId === 16
			if (isUpper || isLower) {
				const upper = isUpper
				const paddingSecond = 10
				const dataSecondFrom = Math.floor(Math.max(0, secondFrom - paddingSecond))
				const dataSecondTo = Math.ceil(Math.min(maxSec, secondTo + paddingSecond))
				if (this.dataManager.hasData(dataSecondFrom, dataSecondTo, upper)) {
					const data = this.dataManager.getData(dataSecondFrom, dataSecondTo, upper)
					const interval = dataSecondTo - dataSecondFrom
					const preData = [this.dataManager.getData(dataSecondFrom - interval, dataSecondFrom, upper)]
					const nextData = [this.dataManager.getData(dataSecondTo, dataSecondTo + interval, upper)]
					amplitude = computeAmplitude(channelId, secondFrom, secondTo, dataSecondFrom, dataSecondTo, data, preData, nextData)
				}
			}
		}
		let addResult = this.eventDataStructure.addEvent(channelId, secondFrom, secondTo, type, priority, amplitude)
		for (let i = 0; i < addResult.overlappedEventId.length; i++) {
			this.pauseRequestManager.editEvent('delete', addResult.overlappedEventId[i], null, null, null, null, this.state.totalEpoch)
		}
		let eventObject = this.eventDataStructure.getEventObjectByEventId(addResult.eventId)
		this.pauseRequestManager.editEvent('add', addResult.eventId, eventObject.secondFrom, eventObject.secondTo, eventObject.channelId, eventObject.type, this.state.totalEpoch)
		this.setStateFromDataStructure()
	}
	deleteEvent(eventId) {
		//console.log('delete event', eventId)
		this.eventDataStructure.deleteEvent(eventId)
		this.pauseRequestManager.editEvent('delete', eventId, null, null, null, null, this.state.totalEpoch)
		this.setStateFromDataStructure()
	}
	moveCursor(second) {
		//console.log('move cursor', second)
		this.timeController.moveCursor(second)
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
		//this.startBuffer()
	}
	zoomChannel(channelId, up) {
		//console.log('zoom channel', channelId, up)
		this.dataManager.zoomChannel(channelId, up)
		this.setStateFromDataStructure()
	}
	upperSelectItem(item) {
		//console.log('upper select item', item)
		this.timeController.setUpperTimeInterval(item)
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
		//this.startBuffer()
	}
	lowerSelectItem(item) {
		//console.log('lower select item', item)
		this.timeController.setLowerTimeInterval(item)
		if (this.state.editable) this.pauseRequestManager.editCurrentWindow(
			this.timeController.getUpperSecondFrom(),
			this.timeController.getLowerSecondFrom(),
			this.timeController.getUpperTimeInterval(),
			this.timeController.getLowerTimeInterval(),
			this.timeController.getCursorSecond(),
			this.state.totalEpoch
		)
		this.checkDataAndSendRequest()
		this.setStateFromDataStructure()
		//this.startBuffer()
	}
	setEventType(eventId, type) {
		//console.log('set event type', eventId, type)
		this.eventDataStructure.setEventType(eventId, type)
		this.pauseRequestManager.editEvent('set', eventId, null, null, null, type, this.state.totalEpoch)
		this.setStateFromDataStructure()
	}
	getEventInfo(eventId) {
		return this.eventDataStructure.getEventObjectByEventId(eventId)
	}
	onStateChange(state) {
		//console.log(PauseRequestManager.start)
		//console.log(state)
		let stateToStr = {}
		stateToStr[PauseRequestManager.get_START()] = ''
		stateToStr[PauseRequestManager.get_UNSAVED()] = '尚未儲存'
		stateToStr[PauseRequestManager.get_SAVING()] = '儲存中'
		stateToStr[PauseRequestManager.get_SAVED()] = '已儲存'
		stateToStr[PauseRequestManager.get_END()] = '已完成'
		//console.log(stateToStr)
		let stateStr = stateToStr[state]
		this.setState({
			stateToShow: stateStr
		})
	}
	async onShowAnswerChecked(checked) {
		if (checked) {
			if (this.answer === null) {
				// ajax to get answer
				// let answerResult = await axios.post('/ajax_answer', { psgFileId: this.state.psgFileId })
				this.setState({
					enableShowAnswerCheckbox: false
				})
				let answerResult = await axios.post('/ajax_answer', { psgFileId: this.state.psgFileId })
				//console.log(answerResult)
				if (!answerResult.data.success) {
					alert(answerResult.data.msg)
					window.history.go(0)
					return
				}
				this.answer = answerResult.data.data
				this.setState({
					enableShowAnswerCheckbox: true,
					answer: this.answer
				})
			} else {
				this.setState({
					answer: this.answer
				})
			}
		} else {
			this.setState({
				answer: null
			})
		}
	}
}

export default Scoring
